var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#3390EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7771 8.47788L7.95706 13.0359C7.15039 13.3599 7.15506 13.8099 7.80906 14.0105L10.8437 14.9572L17.8651 10.5272C18.1971 10.3252 18.5004 10.4339 18.2511 10.6552L12.5624 15.7892H12.5611L12.5624 15.7899L12.3531 18.9179C12.6597 18.9179 12.7951 18.7772 12.9671 18.6112L14.4411 17.1779L17.5071 19.4425C18.0724 19.7539 18.4784 19.5939 18.6191 18.9192L20.6317 9.43388C20.8377 8.60788 20.3164 8.23388 19.7771 8.47788Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.427f63f5b1eec24dbb21a1fbd95386eb.svg";
export { ForwardRef as ReactComponent };